import React from "react";
import ProductCard from "../../components/commalax/product_card";
import { adminCollections, newProducts } from "../../template_codes/commalax/home_page_codes";

const AdminCollections = () => {
  return (
    <div className="flex justify-center items-center flex-wrap flex-col my-10 bg-white py-10">
      <h1 className="text-center text-2xl tracking-widest font-bold italic text-[#F4C0C0] mt-5">
        Admin Collections
      </h1>
      <div className="flex justify-center items-center flex-wrap gap-5 mb-10 mt-5">
        {adminCollections?.map((item, i) => (
          <ProductCard key={i} item={item} />
        ))}
      </div>
    </div>
  );
};

export default AdminCollections;
